import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { oneScheduledTask } from 'app/store/project/scheduled-tasks/scheduled-tasks.selectors';
import { ScheduledTaskOutput } from 'core/http/project/scheduled-tasks/scheduled-tasks.service';
import { selectFirst, to404PageIfNotFound } from 'core/utils/rx-common';
import { Observable } from 'rxjs';

@Injectable()
export class ScheduledTaskResolver {
  constructor(private store$: Store) { }

  resolve(route: ActivatedRouteSnapshot): Observable<ScheduledTaskOutput | undefined> {
    const taskId = route.params.taskId;
    return this.store$
      .pipe(
        selectFirst(oneScheduledTask, { id: taskId }),
        to404PageIfNotFound(this.store$),
      );
  }
}
